import { render, staticRenderFns } from "./setting-storecost.vue?vue&type=template&id=07c79106"
import script from "./setting-storecost.vue?vue&type=script&lang=ts"
export * from "./setting-storecost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports